import React from 'react';
import { useParams } from 'react-router';
import { GLOBAL_CONFIG } from 'config/config';
import { ChildLink, FileToDownload, Page, PageTypes } from 'config/types';
import { DownloadOutlined } from '@ant-design/icons/lib';
import { Button } from 'antd';
import styles from './section.module.scss';
import { ListItem } from 'pages/section/components/list-item';

type IdParams = { id: string; }

export const SectionPage = () => {
  const {id} = useParams<IdParams>();
  const currentPage = GLOBAL_CONFIG.pages.find(
    (page: Page) => page.type === PageTypes.SECTION && page.id === Number(id)
  );

  if (!currentPage) {
    return null;
  }

  const tree = (children: ChildLink[]) => (
	<ul className={styles.list}>
	  {children.map((child, idx) => (
		<ListItem child={child} key={idx}/>
	  ))}
	</ul>
  );

  const downloadFile = (file: FileToDownload): void => {
	const newWin = window.open('');
	newWin!.location.href = file.url;
  };

  if (currentPage.pdfUrl) {
  	return (
	  <div className={styles.sectionPDF}>
		<div className={styles.header}>
		  <h2 className={styles.title}>{currentPage.title}</h2>
		  {currentPage.filesToDownload?.map((file: FileToDownload, idx: number) => (
			<Button key={idx} type="primary" size="large" icon={<DownloadOutlined />} onClick={() => downloadFile(file)}>
			  { file.downloadButtonName }
			</Button>
		  ))}
		</div>
		<div className={styles.content}>
		  <iframe src={currentPage.pdfUrl} width="100%" height="100%"></iframe>
		</div>
	  </div>
	);
  }

  return (
	<div className={styles.section}>
	  <h2 className={styles.title}>{currentPage.title}</h2>
	  <p className={styles.description}>{currentPage.description}</p>
	  <div className={styles.filesToDownload}>
		  {currentPage.filesToDownload?.map((file: FileToDownload, idx: number) => (
                  <Button key={idx} type="primary" size="large" icon={<DownloadOutlined/>}
                          onClick={() => downloadFile(file)}>
                      {file.downloadButtonName}
                  </Button>
              ))}
	  </div>
	  <div className={styles.content}>
		{ tree(currentPage.childrenLinks) }
	  </div>
	</div>
  );
};
